var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component_57_119",
    "data-name": "Component 57 \\u2013 119",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13273",
    "data-name": "Group 13273",
    transform: "translate(-15 -163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12932_-_Outline",
    "data-name": "Path 12932 - Outline",
    d: "M1.5,1.5v6h6v-6h-6M1,0H8A1,1,0,0,1,9,1V8A1,1,0,0,1,8,9H1A1,1,0,0,1,0,8V1A1,1,0,0,1,1,0Z",
    transform: "translate(15 163)",
    fill: "#0d162f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12931_-_Outline",
    "data-name": "Path 12931 - Outline",
    d: "M1.5,1.5v6h6v-6h-6M1,0H8A1,1,0,0,1,9,1V8A1,1,0,0,1,8,9H1A1,1,0,0,1,0,8V1A1,1,0,0,1,1,0Z",
    transform: "translate(15 174)",
    fill: "#0d162f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12933_-_Outline",
    "data-name": "Path 12933 - Outline",
    d: "M1.5,1.5v6h6v-6h-6M1,0H8A1,1,0,0,1,9,1V8A1,1,0,0,1,8,9H1A1,1,0,0,1,0,8V1A1,1,0,0,1,1,0Z",
    transform: "translate(26 163)",
    fill: "#0d162f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12930_-_Outline",
    "data-name": "Path 12930 - Outline",
    d: "M1.5,1.5v6h6v-6h-6M1,0H8A1,1,0,0,1,9,1V8A1,1,0,0,1,8,9H1A1,1,0,0,1,0,8V1A1,1,0,0,1,1,0Z",
    transform: "translate(26 174)",
    fill: "#0d162f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.54ebe640f73f59ee80d409c41ea4ee59.svg";
export { ForwardRef as ReactComponent };